import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'

import { Toaster} from 'sonner'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'

import ErrorPage from './pages/ErrorPage'
import Home from './pages/Home'
import Contact from './pages/Contact'
import OtherProjects from './pages/OtherProjects'
import Project1 from './pages/projects/Project1'
import Project2 from './pages/projects/Project2'
import Project3 from './pages/projects/Project3'
import Project4 from './pages/projects/Project4'
import Project5 from './pages/projects/Project5'
import Project6 from './pages/projects/Project6'
import Project7 from './pages/projects/Project7'
import Project8 from './pages/projects/Project8'
import Project9 from './pages/projects/Project9'

const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: '/',
        element: <Home />
      },
      {
        path: 'contact',
        element: <Contact />
      },
      {
        path: 'otherProjects',
        element: <OtherProjects />
      },
      {
        path: 'project1',
        element: <Project1 />
      },
      {
        path: 'project2',
        element: <Project2 />
      },
      {
        path: 'project3',
        element: <Project3 />
      },
      {
        path: 'project4',
        element: <Project4 />
      },
      {
        path: 'project5',
        element: <Project5 />
      },
      {
        path: 'project6',
        element: <Project6 />
      },
      {
        path: 'project7',
        element: <Project7 />
      },
      {
        path: 'project8',
        element: <Project8 />
      },
      {
        path: 'project9',
        element: <Project9 />
      }
    ]
  }
])

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <Toaster richColors />
    <RouterProvider router={router} />
  </React.StrictMode>
)
